import React from 'react';
import { bankingAwards, forexAwards, insuranceAwards, stockBrokerAwards, realEstateAwards, beautyAwards, touristAwards, influencerAwards } from '../data/nominationsData';

const Nominations = () => {
  return (
    <div className="nominations-page">
      <div className="nominations-container">
        {/* Real Estate Awards */}
        <section className="award-category">
          <h2 className="category-title">Real Estate Award Nominations</h2>
          <a href="#register" className="join-competition-btn">Join the competition</a>
          <ul className="nominations-list">
            {realEstateAwards.map((award, index) => (
              <li key={index}>{award}</li>
            ))}
          </ul>
        </section>

        {/* Beauty Awards */}
        <section className="award-category">
          <h2 className="category-title">Beauty Award Nominations</h2>
          <a href="#register" className="join-competition-btn">Join the competition</a>
          <ul className="nominations-list">
            {beautyAwards.map((award, index) => (
              <li key={index}>{award}</li>
            ))}
          </ul>
        </section>

        {/* Tourist Awards */}
        <section className="award-category">
          <h2 className="category-title">Tourist Award Nominations</h2>
          <a href="#register" className="join-competition-btn">Join the competition</a>
          <ul className="nominations-list">
            {touristAwards.map((award, index) => (
              <li key={index}>{award}</li>
            ))}
          </ul>
        </section>

        {/* Influencer Awards */}
        <section className="award-category">
          <h2 className="category-title">Influencer Nominations</h2>
          <a href="#register" className="join-competition-btn">Join the competition</a>
          <ul className="nominations-list">
            {influencerAwards.map((award, index) => (
              <li key={index}>{award}</li>
            ))}
          </ul>
        </section>

        {/* Banking Awards */}
        <section className="award-category">
          <h2 className="category-title">Banking Award</h2>
          <h3 className="category-subtitle">Nominations</h3>
          <a href="#register" className="join-competition-btn">Join the competition</a>
          <ul className="nominations-list">
            {bankingAwards.map((award, index) => (
              <li key={index}>{award}</li>
            ))}
          </ul>
        </section>

        {/* Forex Brokers Awards */}
        <section className="award-category">
          <h2 className="category-title">Forex Brokers Award</h2>
          <h3 className="category-subtitle">Nominations</h3>
          <a href="#register" className="join-competition-btn">Join the competition</a>
          <ul className="nominations-list">
            {forexAwards.map((award, index) => (
              <li key={index}>{award}</li>
            ))}
          </ul>
        </section>

        {/* Insurance Awards */}
        <section className="award-category">
          <h2 className="category-title">Insurance Award</h2>
          <h3 className="category-subtitle">Nominations</h3>
          <a href="#register" className="join-competition-btn">Join the competition</a>
          <ul className="nominations-list">
            {insuranceAwards.map((award, index) => (
              <li key={index}>{award}</li>
            ))}
          </ul>
        </section>

        {/* Stock Broker Awards */}
        <section className="award-category">
          <h2 className="category-title">Stock Broker Award</h2>
          <h3 className="category-subtitle">Nominations</h3>
          <a href="#register" className="join-competition-btn">Join the competition</a>
          <ul className="nominations-list">
            {stockBrokerAwards.map((award, index) => (
              <li key={index}>{award}</li>
            ))}
          </ul>
        </section>
      </div>
    </div>
  );
};

export default Nominations;